import BenefitCard from "./BenefitCard";
import { useTranslation } from "react-i18next";

const ContinueGroupSection = () => {
  const { t } = useTranslation();

  return (
    <section className="pt-20" id="instructions">
      <div className="text-gray-900 dark:text-white">
        <div className="mb-8">
          <h2 className="text-3xl font-bold mb-4">
            {t("migrationPage.groupContinuation.title")}
          </h2>
          <p className="text-gray-600 dark:text-white/70 text-lg">
            {t("migrationPage.groupContinuation.description")}
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mx-auto mb-4">
          <BenefitCard
            cardNumber={1}
            title={t("migrationPage.groupContinuation.step1.name")}
            description={t("migrationPage.groupContinuation.step1.description")}
          />
          <BenefitCard
            cardNumber={2}
            title={t("migrationPage.groupContinuation.step2.name")}
            description={t("migrationPage.groupContinuation.step2.description")}
          />
          <BenefitCard
            cardNumber={3}
            title={t("migrationPage.groupContinuation.step3.name")}
            description={t("migrationPage.groupContinuation.step3.description")}
          />
        </div>
      </div>
    </section>
  );
};

export default ContinueGroupSection;
